// import { callApi, IApiErrorResponse } from '@/api/callApi';
// import { API_ENDPOINT, API_URL } from '@/api/constant';
import DetailCard, { ICardDetail } from '@/components/common/DetailCard';
import MainHeading from '@/components/common/MainHeading';
import ViewDocumentModal from '@/components/common/ViewDocumentModal';
import EditIcon from '@/components/Icons/EditIcon';
import Layout from '@/components/Layout/Layout';
import FullPageLoader from '@/components/loader/FullPageLoader';
// import { IEmployeeResponse } from '@/interfaces/employee.model';
import { IDocument, IUser } from '@/interfaces/user.model';
import { fetchUserDetails } from '@/redux/features/UserSlice';
import { AppDispatch, RootState } from '@/redux/store';
import {
  calculateDuration,
  genderHandler,
  // showToastNotification,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import { useParams } from 'react-router-dom';

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const [isLoading] = useState<boolean>(false);
  const [isViewModal, setIsViewModal] = useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] =
    useState<null | Partial<IDocument>>(null);
  // const [userDetails, setuserDetails] = useState<IUser | null>(null);
  // const { id } = useParams();
  const toggleModal = () => {
    setIsViewModal(!isViewModal);
  };
  const employeeStatusHandler = (value: string) => {
    if (value === 'current') {
      return (
        <td>
          <span className="badge bg-green-25 fw-normal rounded-pill">
            Current
          </span>
        </td>
      );
    } else if (value === 'risigned') {
      return (
        <td>
          <span className="badge bg-red-25 fw-normal rounded-pill">
            Resigned
          </span>
        </td>
      );
    } else if (value === 'exEmployee') {
      return (
        <td>
          <span className="badge bg-yellow-25 fw-normal rounded-pill">
            Ex-Employee
          </span>
        </td>
      );
    } else if (value === 'transfer') {
      return (
        <td>
          <span className="badge bg-aqua-25 fw-normal rounded-pill">
            Transfer
          </span>
        </td>
      );
    } else if (value === 'terminated') {
      return (
        <td>
          <span className="badge bg-red-25 fw-normal rounded-pill">
            Terminated
          </span>
        </td>
      );
    }
  };
  const bacisDetails: ICardDetail[] = [
    { label: 'Employee Code', value: userDetails?.employeeCode ?? '-' },
    { label: 'Name', value: userDetails?.name },
    { label: 'Gender', value: genderHandler(userDetails?.gender ?? 0) },
    { label: 'Email', value: userDetails?.email },
    { label: 'Personal Email', value: userDetails?.personalEmail },
    { label: 'Contact', value: userDetails?.phone },
    {
      label: 'Date of Birth',
      value: userDetails?.dob
        ? moment(userDetails?.dob).format('DD-MMM-YYYY')
        : '--',
    },
    {
      label: ' Father Name',
      value: userDetails?.userdetail?.fatherName ?? '-',
    },
    {
      label: '    Mother Name',
      value: userDetails?.userdetail?.motherName ?? '-',
    },
    {
      label: '  Joining Date',
      value: userDetails?.dob
        ? moment(userDetails?.joiningDate).format('DD-MMM-YYYY')
        : '--',
    },
    { label: '   Blood Group', value: userDetails?.bloodGroup },
    {
      label: 'Status',
      value: employeeStatusHandler(userDetails?.status || '') ?? '-',
    },
    {
      label: '    Marital Status',
      value: userDetails?.isMarried ? 'Married' : 'Unmarried',
    },
    // { label: '  Skill Type', value: userDetails?.skillType ?? '-' },
  ];
  const permission: ICardDetail[] = [
    { label: 'Department ', value: userDetails?.department?.name },
    { label: 'Designation', value: userDetails?.designation?.name },
    { label: 'Office ', value: userDetails?.site?.name },
  ];
  const advanceDetails: ICardDetail[] = [
    { label: 'UAN No ', value: userDetails?.userdetail?.uanNumber },
    {
      label: 'Aadhar Card No ',
      value: userDetails?.userdetail?.aadharNumber,
    },
    { label: 'PAN Number', value: userDetails?.userdetail?.panNumber },
    { label: '  ESIC Number ', value: userDetails?.userdetail?.esicNumber },
    {
      label: ' Insurance Number ',
      value: userDetails?.userdetail?.insuranceNumber,
    },
    { label: ' PF Number', value: userDetails?.userdetail?.pfNumber },
    {
      label: ' Driving License No. ',
      value: userDetails?.userdetail?.drivingLicenseNumber,
    },
  ];
  const currentAddress: ICardDetail[] = [
    { label: '   Address ', value: userDetails?.userdetail?.address },
    {
      label: '  State',
      value: userDetails?.userdetail?.state,
    },
    { label: 'City ', value: userDetails?.userdetail?.city },
    { label: '  Post Code ', value: userDetails?.userdetail?.pinCode },
  ];
  const permanentAddress: ICardDetail[] = [
    {
      label: '   Address ',
      value: userDetails?.userdetail?.permanentAddress,
    },
    {
      label: '  State',
      value: userDetails?.userdetail?.permanentState,
    },
    { label: 'City ', value: userDetails?.userdetail?.permanentCity },
    {
      label: '  Post Code ',
      value: userDetails?.userdetail?.permanentPinCode,
    },
  ];
  const bankDetails: ICardDetail[] = [
    {
      label: ' Account Holder Name',
      value: userDetails?.userdetail?.accountHolderName,
    },
    {
      label: '  Account Number ',
      value: userDetails?.userdetail?.accountNumber,
    },
    {
      label: 'IFSC/RTGS Code ',
      value: userDetails?.userdetail?.ifscCode,
    },
    { label: 'Bank Name', value: userDetails?.userdetail?.bankName },
    {
      label: 'Branch Address ',
      value: userDetails?.userdetail?.branchAddress,
    },
  ];
  const nomineeDetails: ICardDetail[] = [
    {
      label: 'Relation Type',
      value: userDetails?.userdetail?.nomineeRelation,
    },
    {
      label: 'Name ',
      value: userDetails?.userdetail?.nomineeName,
    },
    {
      label: ' Phone No.',
      value: userDetails?.userdetail?.nomineePhone,
    },
    {
      label: 'Date of Birth',
      value:
        userDetails?.userdetail?.nomineeDob &&
        moment(userDetails?.userdetail?.nomineeDob).format('DD-MMM-YYYY'),
    },
  ];

  // const getuserDetails = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response: IEmployeeResponse = await callApi(
  //       API_URL + API_ENDPOINT.getProfile + `?userId=${id}`,
  //       {
  //         method: 'GET',
  //       },
  //     );
  //     if (response?.status) {
  //       setuserDetails(response?.data);
  //     }
  //   } catch (error) {
  //     if (error && typeof error === 'object' && 'message' in error) {
  //       showToastNotification('danger', (error as IApiErrorResponse).message);
  //     } else {
  //       showToastNotification('danger', 'Something went wrong');
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  useEffect(() => {
    // if (id) {
    dispatch(fetchUserDetails());
    // }
  }, []);
  const HandleUpdate = (data: IUser | null) => {
    navigate(RoutesLink?.updateProfile, { state: { data: data } });
  };
  const handleDocumentClick = (doc: IDocument | string) => {
    const url = typeof doc == 'string' ? doc : doc?.url;
    const docUrl = {
      url,
    };

    setSelectedDocument(docUrl);
    setIsViewModal(true);
  };
  return (
    <>
      <Layout>
        {isLoading ? (
          <FullPageLoader />
        ) : (
          <div className="content container-fluid">
            <MainHeading
              title="Profile"
              buttonIcon={<EditIcon />}
              buttonText="Edit"
              clickHandler={() => HandleUpdate(userDetails)}
              showbBackButton={true}
            />
            <div className="row">
              <div className="col-12 col-lg-12">
                <DetailCard
                  title="Personal Details"
                  cardDetails={bacisDetails}
                  handleDocumentClick={handleDocumentClick}
                  profile={
                    userDetails?.profilePhoto || '/assets/img/employee.svg'
                  }
                />
              </div>
              <div className="col-12 col-lg-12">
                <DetailCard title="Permission" cardDetails={permission} />
              </div>
              <div className="col-12 col-lg-12">
                <DetailCard
                  title="Advance Details"
                  cardDetails={advanceDetails}
                />
              </div>

              <div className="col-12 col-lg-6">
                <DetailCard
                  title="Current Address"
                  cardDetails={currentAddress}
                />
              </div>
              <div className="col-12 col-lg-6">
                <DetailCard
                  title="Permanent Address"
                  cardDetails={permanentAddress}
                />
              </div>
              <div className="col-12 col-lg-6">
                <DetailCard title="Bank Details" cardDetails={bankDetails} />
              </div>
              <div className="col-12 col-lg-6">
                <div className="card manage-user-list">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                      <h4 className="d-flex align-items-center mb-4">
                        Previous Work
                      </h4>
                    </div>
                    {userDetails?.previousworks &&
                    userDetails?.previousworks?.length > 0 ? (
                      userDetails?.previousworks?.map((item, index) => {
                        return (
                          <ul
                            key={index}
                            className="row list-unstyled border border-1 rounded"
                          >
                            <li className="col-12 col-md-6 col-lg-4">
                              <div>
                                <span className="text-muted fs-5 d-block">
                                  Company Name :-
                                </span>
                                {item?.companyName}
                              </div>
                            </li>
                            <li className="col-12 col-md-6 col-lg-4">
                              <div>
                                <span className="text-muted fs-5 d-block">
                                  Designation Name :-
                                </span>
                                {item?.designationName}
                              </div>
                            </li>
                            <li className="col-12 col-md-6 col-lg-4 fs-4">
                              <div>
                                <span className="text-muted fs-5 d-block">
                                  Duration:-
                                </span>
                                <span className="fw-medium fs-5">
                                  {`${moment(item?.fromDate).format(
                                    'DD-MMM-YYYY',
                                  )} To 
                                 ${
                                   item?.toDate
                                     ? moment(item?.toDate).format(
                                         'DD-MMM-YYYY',
                                       )
                                     : 'Currently Working'
                                 }`}
                                </span>
                              </div>
                              {calculateDuration(item?.fromDate, item?.toDate)}
                            </li>
                          </ul>
                        );
                      })
                    ) : (
                      <div className="d-flex justify-content-center">
                        <h4>No work detail found</h4>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <DetailCard
                  title="Documents"
                  documents={userDetails?.documents}
                  handleDocumentClick={handleDocumentClick}
                />
              </div>
              <div className="col-12 col-lg-8">
                <DetailCard
                  title="Nominee Details"
                  cardDetails={nomineeDetails}
                  handleDocumentClick={handleDocumentClick}
                />
              </div>
            </div>
          </div>
        )}
      </Layout>
      <ViewDocumentModal
        isOpen={isViewModal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
};
export default Profile;
